import { useMemoizedFn, useMount } from 'ahooks';
import { Form, Radio, Tabs } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useAppDispatch } from 'app/hooks';
import { StepActionTypeEnum, SvcShowTypeEnum } from 'domains/skuDomain';
import { useSkuSvcRole } from 'hooks/useSkuSvcRole';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StepComponentProps } from '.';
import { JobOptionConfig } from '../components/JobOptionConfig';
import { JobOptionRender } from '../components/JobOptionRender';
import './Step7RequiredServices.less';

export const Step7RequiredServices = (props: StepComponentProps) => {
  const { sku, topSku } = props;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const [curValue, setCurValue] = useState('config');
  const skuSvcRole = useSkuSvcRole(sku);
  const svcConfigRef = useRef<any>();
  const svcRenderRef = useRef<any>();

  const defaultSvcConfig = useMemoizedFn(() => {
    form.setFieldsValue({
      skipRequiredSvc: Boolean(sku?.skipRequiredSvc),
    });
  });

  useMount(async () => {
    dispatch.sku.setRevxSpinloading(true);
    try {
      dispatch.sku.registerStepAction({
        [StepActionTypeEnum.STEP7_REQUIREDSERVICES]: submit,
      });
      defaultSvcConfig();
      dispatch.sku.setRevxSpinloading(false);
    } catch {
      dispatch.sku.setRevxSpinloading(false);
    }
  });

  // const submit = useMemoizedFn(async (payload: PartialSKU) => {
  //   if (sku.readonly) {
  //     return true;
  //   }
  //   // setIsSubmit(true);
  //   // if (
  //   //   !payload.requiredSvcTypeIds?.length &&
  //   //   !payload.requiredSvcIds?.length
  //   // ) {
  //   //   return false;
  //   // }
  //   try {

  //   } catch {
  //     // do nothing when form invalid
  //     return false;
  //   }
  // });

  const subSubmit = async () => {
    try {
      setLoading(true);
      if (sku.readonly || Boolean(topSku)) {
        return true;
      }
      if (typeof svcConfigRef.current?.submit === 'function') {
        await svcConfigRef.current.submit();
      }
      if (typeof svcRenderRef.current?.submit === 'function') {
        await svcRenderRef.current.submit();
      }
      setLoading(false);
      return true;
    } catch {
      setLoading(false);
      return false;
    }
  };

  const submit = useMemoizedFn(async () => {
    try {
      if (sku.readonly) {
        return true;
      }
      const value = await form.validateFields();

      const res = await dispatch.sku.updateSvc({
        ...value,
        version: sku.version,
        id: sku.id,
      });
      // const res = await subSubmit();

      return res;
    } catch (e) {
      console.log(e);
      return false;
    }
  });

  return (
    <>
      <div className="single-sku-config-wizard-step-title">
        {t('platform.sku.wizard.required')}{' '}
        <span className="brand-green">{t('platform.sku.wizard.services')}</span>
      </div>
      <Form form={form} className="single-sku-config-require-services">
        <Form.Item
          label={t(
            'platform.sku.wizard.quantity.form.label.requiredServicesSkip'
          )}
          name="skipRequiredSvc"
          hidden={!skuSvcRole.isRequiredSvc}
        >
          <Radio.Group disabled={sku.readonly || Boolean(topSku)}>
            <Radio value={true}>
              <span>Yes</span>
            </Radio>
            <Radio value={false}>
              <span>No</span>
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
      <Tabs
        activeKey={curValue}
        animated={false}
        destroyInactiveTabPane={true}
        className="commonOneofFormTabs-default"
        onChange={async (val: string) => {
          if (loading) return false;
          const res = await subSubmit();
          if (res) {
            setCurValue(val);
          }
        }}
      >
        <Tabs.TabPane
          tab="Services"
          key={'config'}
          disabled={sku.readonly || Boolean(topSku)}
        >
          <JobOptionConfig
            {...props}
            onRef={svcConfigRef}
            disabled={sku.readonly || Boolean(topSku)}
            showType={SvcShowTypeEnum.REQUIRED}
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab="Service Parameters"
          key={'show'}
          disabled={sku.readonly || Boolean(topSku)}
        >
          <JobOptionRender
            {...props}
            onRef={svcRenderRef}
            disabled={sku.readonly || Boolean(topSku)}
            showType={SvcShowTypeEnum.REQUIRED}
          />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};
